import { c as _c } from "react/compiler-runtime";
import { Stack, type SxProps, type Theme } from '@mui/material';
import { useScrollable } from './useScrollable';
export const ScrollableHeader = t0 => {
  const $ = _c(12);
  const {
    children,
    hideBorderWhenOnTop,
    className,
    sx
  } = t0;
  const {
    isScrolledVertically
  } = useScrollable();
  const t1 = hideBorderWhenOnTop ? "none" : "1px solid var(--mui-palette-divider)";
  const t2 = isScrolledVertically ? "var(--mui-customShadows-panel)" : undefined;
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = {
      borderBottom: t1,
      boxShadow: t2,
      transition: "box-shadow 200ms ease"
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== sx) {
    t4 = Array.isArray(sx) ? sx : [sx ?? false];
    $[3] = sx;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3 || $[6] !== t4) {
    t5 = [t3, ...t4];
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== children || $[9] !== className || $[10] !== t5) {
    t6 = <Stack className={className} sx={t5}>{children}</Stack>;
    $[8] = children;
    $[9] = className;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};